<template>
  <div class="wrapper profile" :class="{'profile-mobile': isMobile}">
    <v-card>
      <ct-row wrap="nowrap" align="center">
        <ct-col class="card__item" :span="18">
          <span class="avatar-container">
            <ct-avatar
              class="large-avatar"
              :src="profile.avatar">
              <edit-avatar></edit-avatar>
            </ct-avatar>
          </span>
          <div class="user-info">
            <p class="user-info-nick">
              <span>{{ profile.nickname }}</span>
              <edit-nickname></edit-nickname>
            </p>
            <p class="user-info-email">
              <ct-icon name="email"></ct-icon>
              <span>{{ profile.email }}</span>
            </p>
          </div>
        </ct-col>
        <ct-col class="card__right" :span="6" v-if="!isMobile">
          <ct-button type="secondary" @click.stop="resetPassword">{{ $t('auth.ResetPassword') }}
            <ct-icon name="loading" data-animate="spin" v-show="emailSending"></ct-icon>
          </ct-button>
        </ct-col>
      </ct-row>
      <div class="zichan">
        <span class="zichan-content">
          <ct-icon :multiColor="true" name="proton"></ct-icon>
          <span>{{ profile.proton }}</span>
          <span class="zichan-content-unit">{{ $t('user.Proton') }}</span>
        </span>
        <span class="zichan-content">
          <ct-icon :multiColor="true" name="neutron"></ct-icon>
          <span>{{ profile.neutron }}</span>
          <span class="zichan-content-unit">{{ $t('user.Neutron') }}</span>
        </span>
        <br>
        <p class="zichan-introduce">
          <ct-link @click.prevent="introduceZichan" type="text_secondary_light">{{ $t('user.ProtonNeutronTips') }}</ct-link>
        </p>
      </div>
      <div class="signature">
        <h4 class="signature-title">
          <span>{{ $t('user.Signature') }}</span>
          <edit-aptions></edit-aptions>
        </h4>
        <p class="signature-content">{{ profile.signature }}</p>
      </div>
      <ct-button v-if="isMobile" class="reset-password" type="secondary" @click.stop="resetPassword">{{ $t('auth.ResetPassword') }}
        <ct-icon name="loading" data-animate="spin" v-show="emailSending"></ct-icon>
        </ct-button>
    </v-card>
    <reset-password :visible="resetPasswordVisible" @close="closeReset"></reset-password>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VCard from '@ca/components/Card'
import CtAvatar from '@ca/components/CtAvatar'
import EditAptions from './sub/EditAptions'
import EditNickname from './sub/EditNickname'
import EditAvatar from './sub/EditAvatar'
// import api from '@ca/api'
import ResetPassword from '@/components/reset-password/index'

export default {
  name: 'UserHome',
  components: {
    'v-card': VCard,
    'ct-avatar': CtAvatar,
    'edit-nickname': EditNickname,
    'edit-aptions': EditAptions,
    'edit-avatar': EditAvatar,
    ResetPassword
  },
  data () {
    return {
      emailSending: false,
      resetPasswordVisible: false,
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    ...mapGetters(['profile', 'isAuthenticated', 'isAdminRole'])
  },
  methods: {
    ...mapActions(['getProfile', 'updateUserInfo']),
    closeReset () {
      this.resetPasswordVisible = false
    },
    resetPassword () {
      this.resetPasswordVisible = true
      //   this.emailSending = true
      //   const res = api.sendEmailToReset({
      //     params: {
      //       email: this.profile.email
      //     }
      //   })
      //   res.then(res => {
      //     if (res.data.code === 1) {
      //       this.$alert({ message: 'We\'ve sent a message to your email. Log in your email and check the inbox, follow the instructions in this message to reset password.' })
      //     } else if (res.data.code === -1) {
      //       this.$alert({ message: 'You have used up all the chance to reset your password, please try again tomorrow.' })
      //     } else {
      //       this.$toast({ message: res.data.error, type: 'error', duration: 2000 })
      //     }
      //     this.emailSending = false
      //   }).catch(() => {
      //     this.$toast({ message: 'Oops…Something is wrong, please try again later.', type: 'error', duration: 2000 })
      //     this.emailSending = false
      //   })
    },
    introduceZichan () {
      // Todo: 组件添加换行
      this.$confirm({
        title: this.$t('user.ProtonNeutronIntroduction'),
        message: `1. 质子类似于游戏金币，目前没有直接用途。未来，可能将用于解锁新的功能、获取新的内容。\n2. 中子类似于经验值，数量反映了用户学习网站内容的多寡。\n3. 质子和中子只能通过学习行为获得，不能花钱充值，也不能转让给其它用户。`,
        confirmButtonText: this.$t('user.IGetIt')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';

.profile {
  margin-top: 56px;

  .card {
    background: url('../../../../assets/img/comet/home/user-qiu.png') no-repeat right bottom;
    background-size: 190px 150px;
    padding: 70px 96px;

    svg + span,
    span + svg,
    i + span,
    span + i {
      margin-left: 8px;
    }

    .ct-icon-pencil {
      cursor: pointer;
    }

    .avatar-container {
      display: inline-block;
      vertical-align: middle;
      border-radius: 50%;
      width: 124px;
      height: 124px;
      background-color: #fff;
      border: 4px solid $primary;
      padding: 1px;
      margin-right: 32px;
      overflow: hidden;

      .avatar {
        width: 100%;
        height: 100%;
      }
    }

    .user-info {
      display: inline-block;
      vertical-align: middle;
      margin: 10px 0;

      &-nick {
        font-size: 20px;
        font-family: SFProDisplay-Medium;
        font-weight: 500;
        color: rgba(26, 61, 94, 1);
        line-height: 20px;
        margin-bottom: 16px;

        .ct-button {
          padding: 0;
          font-size: 18px;
          height: auto;
        }
      }

      &-email {
        font-size: 16px;
        font-family: SFProDisplay-Regular;
        font-weight: 400;
        color: rgba(118, 139, 158, 1);
        line-height: 16px;
      }
    }

    &__right {
      text-align: right;
    }

    .zichan {
      margin-top: 32px;

      &-content {
        font-size: 14px;
        font-family: SFProDisplay-Regular;
        font-weight: 500;
        color: $secondary;
        line-height: 16px;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 10px;

        &-unit {
          font-weight: 400;
          margin-left: 3px;
          margin-right: 16px;
        }
      }

      &-introduce {
        font-size: 12px;
        font-family: SFProDisplay-Regular;
        font-weight: 400;
        color: rgba(163, 177, 191, 1);
        line-height: 12px;
        margin-bottom: 32px;
      }
    }

    .signature {
      &-title {
        font-size: 18px;
        font-family: SFProDisplay-Regular;
        font-weight: 400;
        color: rgba(26, 61, 94, 1);
        line-height: 16px;
        margin-bottom: 16px;

        .ct-button {
          padding: 0;
          font-size: 18px;
          height: auto;
        }
      }

      &-content {
        font-size: 16px;
        font-family: SFProText-Regular;
        font-weight: 400;
        color: rgba(118, 139, 158, 1);
        line-height: 24px;
        word-break: break-all;
        word-break: break-word;
      }
    }
  }
}
.profile-mobile {
    .card {
        padding: 0px 10px 10px 10px;
        .card__right {
            .ct-button {
                padding: 0;

            }
        }
    }
    .reset-password {
        margin-top: 20px;
    }
}
</style>
